import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import { useTheme } from '../context/ThemeContext';
import '../styles/LoadingFallback.css'; // استيراد ملف CSS الجديد

/**
 * LoadingFallback component
 * Used as a fallback for React.Suspense when lazy loading components
 */
const LoadingFallback = () => {
  const { language } = useLanguage();
  const { theme } = useTheme();
  const isArabic = language === 'ar';
  
  const defaultMessage = isArabic ? 'جاري تحميل الصفحة...' : 'Loading page...';
  
  return (
    <div className={`loading-fallback-container ${theme}`}>
      <div className="loading-fallback-content">
        <div className="loading-spinner" />
        <p className="loading-message">
          {defaultMessage}
        </p>
      </div>
    </div>
  );
};

export default LoadingFallback;